import { useEffect, useState } from "react";
import "./Card.css";




const Card = (props) =>{
    const [readmore,setReadMore] = useState(false);
    const data = props.data;
    function clickHander(){
        setReadMore(!readmore);
       }
    return (
        
      <nav className="card" key={data.id}>
                <div data-aos="fade-right">
                    <p className="edu-exp1">{data.time}</p>
                    <h3 className="hadding">{data.title}</h3>
                    
                        <p className="edu-exp">
                            {readmore ? (data.discription +"...") : (data.discription.substring(0,76)+"...")}
                            <span className="text-blue-600" onClick={clickHander}>{
                                readmore ? "Show less":"Read more"
                            }</span>
                        </p>
                    
                </div>
                </nav>
        
    );
}
export default Card